'use client'
import { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { signOut, useSession } from 'next-auth/react';

export default function Header() {
    const { data: session, status } = useSession();
    const [menuOpen, setMenuOpen] = useState(false);
    const router = useRouter();

    const isLoggedIn = status === 'authenticated';
    const user = session?.user;
    const isAdmin = user?.role === 'master_admin' || user?.isAdmin === true;

    const handleLogout = async () => {
        try {
            const callback = process.env.NEXT_PUBLIC_APP_URL || 'https://ghg2001.com';
            await signOut({ redirect: true, callbackUrl: callback });
        } catch (e) {
            console.warn('SignOut error', e);
        }
        setMenuOpen(false);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const handleLinkClick = () => {
        closeMenu();
    };

    return (
        <>
            <header>
                <div className="container">
                    <div className="header_cont">
                        <Link href="/" className="logo">
                            <img src="/img/logo.png" alt="Logo" />
                        </Link>

                        {/* Mobile Menu Toggle */}
                        <button
                            className={`menu-toggle ${menuOpen ? 'active' : ''}`}
                            onClick={toggleMenu}
                            aria-label="Toggle menu"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>

                        <nav className={menuOpen ? 'active' : ''}>
                            <ul>
                                <li>
                                    <Link href="/" onClick={handleLinkClick}>Home</Link>
                                </li>
                                <li>
                                    <Link href="/reunion" onClick={handleLinkClick}>About Reunion</Link>
                                </li>
                                <li>
                                    <Link href="/profiles" onClick={handleLinkClick}>Profiles</Link>
                                </li>
                                {isLoggedIn ? (

                                    <li>
                                        <Link href="/gallery" onClick={handleLinkClick}>Gallery</Link>
                                    </li>
                                ) : null}

                                <li>
                                    <Link href="/donations" onClick={handleLinkClick}>Donations</Link>
                                </li>
                                <li>
                                    <Link href="/contact" onClick={handleLinkClick}>Contact</Link>
                                </li>
                                {!isLoggedIn ? (
                                    <>
                                        <li>
                                            <Link href="/registration" className="reg_btn" onClick={handleLinkClick}>
                                                Registration
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="/login" className="reg_btn" onClick={handleLinkClick}>
                                                Login
                                            </Link>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        {user?.id && (
                                            <li>
                                                <Link href={`/profile/${user.id}`} onClick={handleLinkClick}>
                                                    My Profile
                                                </Link>
                                            </li>
                                        )}

                                        <li>
                                            <button className="logout_reg_btn" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                                                Logout
                                            </button>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </header>

            {/* Overlay for mobile */}
            <div
                className={`overlay ${menuOpen ? 'active' : ''}`}
                onClick={closeMenu}
            />
        </>
    );
}